export default __webpack_public_path__ + "static/media/parc3.c13ea03f.png";